import { TranslationKey } from 'i18next/resources';

export const errorReasonKeys: Record<string, TranslationKey> = {
  'Wrong credentials': 'login_form.error.wrong_credentials',
  'Invalid token': 'login_form.error.wrong_credentials',
  'Account empty': 'login_form.error.account_empty',
  'Bank not supported': 'login_form.error.unsupported_bank',
  'Unknown login failed reason': 'login_form.error.internal_server_error',
  'Unknown login status': 'login_form.error.internal_server_error',
  'Demo server error': 'common.error',
  'Regshield server error': 'common.error'
} as const;
